module.exports = __webpack_public_path__ + "img/HandymanOutlined.7abe49e9.svg";